// import axios from 'axios';
import { SELECT_FLIGHT_EXTRAS as SELECT_FLIGHT_EXTRAS_STEP } from 'state/checkoutPage/wizard/constants/stepsKeys';
import setSelectedFlightsExtrasInitialValue from 'state/checkoutPage/travelSummary/operations/setSelectedFlightsExtrasInitialValue';
import setSelectedOtherExtrasInitialValue from 'state/checkoutPage/travelSummary/operations/setSelectedOtherExtrasInitialValue';
// import fetchFlightsDetails from 'state/checkoutPage/flightsDetails/operations/fetchFlightsDetails';
import { setLastEnabledStep as checkoutWizardSetLastEnabledStep } from 'state/checkoutPage/wizard/actions';
import { setSelectedFlights as travelSummarySetSelectedFlights } from 'state/checkoutPage/travelSummary/actions';
import { resetState as cancellationProtectionsResetState } from 'state/checkoutPage/cancellationProtections/actions';
import { resetFlightsDetails as checkoutFlightsDetailsResetFlightsDetails } from 'state/checkoutPage/flightsDetails/actions';
import { resetInsurances as checkoutInsurancesResetInsurances } from 'state/checkoutPage/insurances/actions';
import { resetPaymentKlarna as checkoutPaymentKlarnaResetPaymentKlarna } from 'state/checkoutPage/paymentKlarna/actions';
import { resetState as checkoutPaymentResetPaymentOptions } from 'state/checkoutPage/paymentOptions/actions';
import { resetPromotionCode as checkoutPromotionCodeResetPromotionCode } from 'state/checkoutPage/promotionCode/actions';
import { resetTransfers as checkoutTransfersResetTransfers } from 'state/checkoutPage/transfers/actions';
import { resetState as vehicleRentalResetState } from 'state/checkoutPage/vehicleRental/actions';

// const CancelToken = axios.CancelToken;
// let source;

export default function onFlightCombinationSelected(selectedFlights) {
  return (dispatch) => {
    dispatch(travelSummarySetSelectedFlights(selectedFlights));
    dispatch(checkoutWizardSetLastEnabledStep(SELECT_FLIGHT_EXTRAS_STEP));
    dispatch(setSelectedFlightsExtrasInitialValue(true));
    dispatch(setSelectedOtherExtrasInitialValue());
    dispatch(checkoutPaymentKlarnaResetPaymentKlarna());
    dispatch(checkoutPaymentResetPaymentOptions());
    dispatch(checkoutPromotionCodeResetPromotionCode());
    dispatch(checkoutTransfersResetTransfers());
    dispatch(checkoutInsurancesResetInsurances());
    dispatch(cancellationProtectionsResetState());
    dispatch(checkoutFlightsDetailsResetFlightsDetails());
    dispatch(vehicleRentalResetState());

    // if (source) {
    //   source.cancel({ requestCancelled: true });
    // }

    // source = CancelToken.source();
    // dispatch(fetchFlightsDetails({ cancelToken: source.token }));
  };
}
